module.exports = __webpack_public_path__ + "img/logo_text.cbec0277.svg";